// ChatMessages.js
import { DateTimeFormater } from "../../../services/Helper";
import { Link } from "react-router-dom";
import React, { useState } from "react";

const ChatMessages = ({
  messages,
  isNoMessage,
  NoMessageText,
  loadingButtons,
  markReadMessage,
  containerRef,
  isLoadingOlder,
  hasMoreMessages,
}) => {
  const [previewImg, setPreviewImg] = useState(null);

  const handleImageClick = (url) => {
    setPreviewImg(url);
  };

  const closePreview = () => {
    setPreviewImg(null);
  };

  if (isNoMessage) {
    return (
      <div className="chat-empty">
        <i className="fas fa-inbox chat-empty__icon" aria-hidden="true" />
        <p className="chat-empty__text">
          {NoMessageText === "" ? "No message found" : NoMessageText}
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="chat-messages" ref={containerRef}>
        {isLoadingOlder && (
          <div className="chat-messages__status">
            <i className="fas fa-spinner fa-spin" aria-hidden="true" />
            Loading older messages...
          </div>
        )}
        {!hasMoreMessages && messages.length > 0 && !isLoadingOlder && (
          <div className="chat-messages__status chat-messages__status--muted">
            Older messages may not be viewable here
          </div>
        )}

        {messages.map((msg, index) => {
         const isOutbound = msg.isStaffMessage === true || msg.sender === "pillpharm";
         const senderLabel = msg.sender === "pillpharm" ? "Pillpharm" : msg.sender;

          return (
            <div
              key={msg._id || index}
              className={`chat-message ${isOutbound ? "chat-message--outbound" : "chat-message--inbound"}`}
            >
              <div className="chat-message__header">
                <span className="chat-message__sender">{senderLabel}</span>
                {msg.orderIdLabel && (
                  <span className="chat-message__order">
                    (
                    {msg.order ? (
                      <Link to={`/orders/${msg.order}`}>{msg.orderIdLabel}</Link>
                    ) : (
                      msg.orderIdLabel
                    )}
                    )
                  </span>
                )}
              </div>

              <div
                className={`chat-bubble ${isOutbound ? "chat-bubble--outbound" : "chat-bubble--inbound"}`}
              >
                <p className="chat-bubble__body">{msg.body}</p>

                {msg.media && msg.media.length > 0 && (
                  <div className="chat-bubble__media">
                    {msg.media.map((url, mediaIndex) => (
                      <button
                        key={mediaIndex}
                        type="button"
                        className="chat-bubble__media-btn"
                        onClick={() => handleImageClick(url)}
                      >
                        <img src={url} alt={`Attachment ${mediaIndex + 1}`} />
                      </button>
                    ))}
                  </div>
                )}

                <div className="chat-bubble__footer">
                  <time className="chat-bubble__time">
                    {DateTimeFormater(msg.creationDate)}
                  </time>

                  {!isOutbound && !msg.read && (
                    <button
                      type="button"
                      className="chat-bubble__read-btn"
                      onClick={() => markReadMessage(msg._id)}
                      disabled={loadingButtons[msg._id]}
                      title="Mark as read"
                    >
                      {loadingButtons[msg._id] ? (
                        <i className="fas fa-spinner fa-spin" aria-hidden="true" />
                      ) : (
                        <i className="fas fa-check" aria-hidden="true" />
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {previewImg && (
        <div
          className="chat-image-preview"
          onClick={closePreview}
          role="presentation"
        >
          <img src={previewImg} alt="Attachment preview" />
        </div>
      )}
    </>
  );
};

export default ChatMessages;
